
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M21 18C21.55 18 22 17.55 22 17V11C22 10.45 21.55 10 21 10C20.45 10 20 10.45 20 11V17C20 17.55 20.45 18 21 18ZM20 22H22V20H20V22ZM4.40999 22H18V11C18 9.34002 19.34 8.00002 21 8.00002H22V4.41002C22 3.52002 20.92 3.07002 20.29 3.70002L3.70999 20.29C3.07999 20.92 3.51999 22 4.40999 22Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-signal-cellular-connected-no-internet-4-bar`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSignalCellularConnectedNoInternet4Bar

    ```js
    <b-new-b-icon-signal-cellular-connected-no-internet-4-bar />
    ```
</docs>


